import { z } from "zod";

// Minimal form schema; fields come from HIPAA_DEF and vary by type.
export const recordRequestFormSchema = z.record(z.any());

export const recordRequestStatusSchema = z.object({
  identityVerified: z.boolean().default(false),
  signatureCompleted: z.boolean().default(false),
  phase: z.union([z.literal(1), z.literal(2), z.literal(3)]).default(1),
});

export const recordRequestPayloadSchema = z.object({
  form: recordRequestFormSchema,
  step: z.number().int().default(0),
  status: recordRequestStatusSchema,
});

export type RecordRequestPayload = z.infer<typeof recordRequestPayloadSchema>;

